import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getTestId, GridCol } from '@airtel/air-design-system';
import { Children } from 'react';
import { View } from 'react-native';
import { getDualColumnSectionStyles } from './DualColumnSectionStyles';
var DualColumnSectionStyles = getDualColumnSectionStyles();
export var DualColumnSectionComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'DualColumnSection' : _props$testID,
    style = props.style,
    halfSizeUpperColumnStyle = props.halfSizeUpperColumnStyle,
    halfSizeLowerColumnStyle = props.halfSizeLowerColumnStyle,
    children = props.children,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'leftMajor' : _props$variant,
    fullSizeColumnStyle = props.fullSizeColumnStyle,
    innerContainerStyle = props.innerContainerStyle;
  var widgetArray = Children.toArray(children);
  var gridConfig = {
    quad: [[halfColumnGridCard(widgetArray[0], widgetArray[1], halfSizeUpperColumnStyle, halfSizeLowerColumnStyle)], [halfColumnGridCard(widgetArray[2], widgetArray[3], halfSizeUpperColumnStyle, halfSizeLowerColumnStyle)]],
    rightMajor: [[halfColumnGridCard(widgetArray[0], widgetArray[1], halfSizeUpperColumnStyle, halfSizeLowerColumnStyle)], [fullColumnGridCard(widgetArray[2], fullSizeColumnStyle, innerContainerStyle)]],
    leftMajor: [[fullColumnGridCard(widgetArray[0], fullSizeColumnStyle, innerContainerStyle)], [halfColumnGridCard(widgetArray[1], widgetArray[2], halfSizeUpperColumnStyle, halfSizeLowerColumnStyle)]],
    dual: [[fullColumnGridCard(widgetArray[0], fullSizeColumnStyle, innerContainerStyle)], [fullColumnGridCard(widgetArray[1], fullSizeColumnStyle, innerContainerStyle)]]
  };
  return _jsx(View, Object.assign({}, getTestId(testID), {
    style: [DualColumnSectionStyles.sectionContainerStyle, style]
  }, {
    children: gridConfig[variant].map(row => row.map(col => _jsx(_Fragment, {
      children: col
    })))
  }));
};
DualColumnSectionComponent.genericRendererKey = 'AirDualColumnSection';
DualColumnSectionComponent.isAirSection = true;
var halfColumnGridCard = (upperChild, lowerChild, halfSizeUpperColumnStyle, halfSizeLowerColumnStyle) => {
  return _jsxs(View, Object.assign({
    style: DualColumnSectionStyles.container
  }, {
    children: [upperChild && _jsx(GridCol, Object.assign({
      noGutter: true,
      noTopGutter: true,
      style: [DualColumnSectionStyles.topHalfContainerDefaultStyle, halfSizeUpperColumnStyle],
      breakpoints: {
        xs: 12
      }
    }, {
      children: upperChild
    })), lowerChild && _jsx(GridCol, Object.assign({
      noGutter: true,
      noTopGutter: true,
      style: [DualColumnSectionStyles.bottomHalfContainerDefaultStyle, halfSizeLowerColumnStyle],
      breakpoints: {
        xs: 12
      }
    }, {
      children: lowerChild
    }))]
  }));
};
var fullColumnGridCard = (children, fullSizeColumnStyle, innerContainerStyle) => {
  return children && _jsx(GridCol, Object.assign({
    noGutter: true,
    noTopGutter: true,
    breakpoints: {
      xs: 6
    },
    childrenStyle: innerContainerStyle,
    style: [DualColumnSectionStyles.fullSizeColumnStyle, fullSizeColumnStyle]
  }, {
    children: children
  }));
};